var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { useState } from "@wordpress/element";
import { useTaskActions } from "../../hooks/actions/useTaskActions";
import { Loading } from "../Loading/Loading";
function TaskCardActions({ task, onDoneStatusChange, className = "" }) {
    const { changeTaskDoneStatus } = useTaskActions();
    const [loading, setLoading] = useState(false);
    const isTaskCompleted = task.is_done;
    const changeDone = (done) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield changeTaskDoneStatus(task.id, done, (isCompleted) => {
            onDoneStatusChange(task.id, isCompleted);
        });
        setLoading(false);
    });
    if (loading) {
        return _jsx(Loading, { ovalSize: "24", className: "wpqt-mt-auto" });
    }
    return (_jsx("div", { className: `wpqt-flex wpqt-justify-center wpqt-mt-auto ${className}`, children: isTaskCompleted ? (_jsx(CheckBadgeIcon, { className: "wpqt-size-6 wpqt-icon-green", onClick: (e) => {
                e.stopPropagation();
                changeDone(false);
            } })) : (_jsx(CheckBadgeIcon, { className: "wpqt-size-6 wpqt-text-gray-300", onClick: (e) => {
                e.stopPropagation();
                changeDone(true);
            } })) }));
}
export { TaskCardActions };
